import Box from "@mui/material/Box/Box";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  FormControl,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  SxProps,
  TextField,
  Typography,
} from "@mui/material";
import { Dayjs } from "dayjs";
import { useMemo, useState } from "react";
import { StoreData } from "../../../../types/types";
import { PrimaryButton } from "../../../../components/general/buttons/PrimaryButton";
import useFetchServiceStoreFromStore from "../../../../hooks/entities/useFetchServiceStoreFromStore";
import { useAuth } from "../../../../context/AuthProvider/useAuth";
import { isUserStoreManager } from "./functions";
import { IEmployee } from "../../../../services/api/Employee/types";
import { useTranslation } from "react-i18next";

interface CreateAppointmentModalProps {
  onClose: VoidFunction;
  selectedDate: Dayjs;
  employeeStores: StoreData[];
  userEmployees: IEmployee[];
}

// implement later
const CreateAppointmentModal = (props: CreateAppointmentModalProps) => {
  const { t } = useTranslation();
  const {
    onClose,
    selectedDate,
    employeeStores: propsEmployeeStores,
    userEmployees,
  } = props;

  const { id: userId } = useAuth().user;

  const employeeStores = useMemo(
    () => propsEmployeeStores.slice(1),
    [propsEmployeeStores]
  );


  const [selectedStoreIndex, setSelectedStoreIndex] = useState(0);

  const selectedStore = employeeStores[selectedStoreIndex];

  const { serviceStores: fetchedServiceStores, loading: servicesLoading } =
    useFetchServiceStoreFromStore(selectedStore?.id);

  const serviceStores = isUserStoreManager(userId, selectedStore.managerId)
    ? fetchedServiceStores
    : [];

  const [selectedServiceStoreIndex, setSelectedServiceStoreIndex] = useState(0);

  const selectedServiceStore = serviceStores[selectedServiceStoreIndex];

  const [selectedTimeIndex, setSelectedTimeIndex] = useState(0);

  return (
    <Box sx={styles.container}>
      <IconButton
        onClick={onClose}
        sx={{ margin: "-20px -20px 0px 0px", alignSelf: "flex-end" }}
      >
        <CloseIcon />
      </IconButton>

      <Box>
        <Typography variant="h6" fontWeight="bold">
          {t("appointmentDetails.comercialAppointments.createModal.title", {date: selectedDate?.format("DD/MM/YYYY")})}
        </Typography>
      </Box>

      <FormControl size="small" fullWidth>
        <InputLabel>{t("appointmentDetails.comercialAppointments.createModal.storeLabel")}</InputLabel>
        <Select
          label={t("appointmentDetails.comercialAppointments.createModal.storeLabel")}
          value={selectedStoreIndex}
          onChange={(e) => setSelectedStoreIndex(Number(e.target.value))}
        >
          {employeeStores.map((store, index) => (
            <MenuItem value={index} key={store.id}>
              <ListItem disablePadding>
                <ListItemText primary={store.name} />
              </ListItem>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {!servicesLoading && (
        <FormControl size="small" fullWidth>
          <InputLabel>{t("appointmentDetails.comercialAppointments.createModal.serviceLabel")}</InputLabel>
          <Select
            label={t("appointmentDetails.comercialAppointments.createModal.serviceLabel")}
            value={selectedServiceStoreIndex}
            onChange={(e) =>
              setSelectedServiceStoreIndex(Number(e.target.value))
            }
          >
            {serviceStores &&
              serviceStores.map((serviceStore, index) => (
                <MenuItem value={index} key={serviceStore.id}>
                  <ListItem disablePadding>
                    <ListItemText primary={serviceStore.serviceName} />
                  </ListItem>
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}

      <FormControl size="small" fullWidth>
        <InputLabel>{t("appointmentDetails.comercialAppointments.createModal.employeeLabel")}</InputLabel>
        {/* <Select
          label="Funcionário *"
          value={selectedStoreIndex}
          onChange={(e) => setSelectedStoreIndex(e.target.value)}
        >
          {employeeStores.map(
            (store, index) =>
              index > 0 && (
                <MenuItem value={store?.id} key={store.id}>
                  <ListItem disablePadding>
                    <ListItemText primary={store.name} />
                  </ListItem>
                </MenuItem>
              )
          )}
        </Select> */}
      </FormControl>

      <FormControl size="small" fullWidth>
        <InputLabel>{t("appointmentDetails.comercialAppointments.createModal.timeLabel")}</InputLabel>
        <Select
          label={t("appointmentDetails.comercialAppointments.createModal.timeLabel")}
          value={selectedTimeIndex}
          onChange={(e) => setSelectedTimeIndex(Number(e.target.value))}
        >
          {employeeStores.map((store, index) => (
            <MenuItem value={index} key={store.id}>
              <ListItem disablePadding>
                <ListItemText primary={store.name} />
              </ListItem>
            </MenuItem>
          ))}
        </Select>
      </FormControl>


      <TextField fullWidth size="small" label={t("appointmentDetails.comercialAppointments.createModal.clientNameLabel")} />
        <PrimaryButton label={t("appointmentDetails.comercialAppointments.createModal.createButton")} />
      </Box>
  );
};

export default CreateAppointmentModal;

const styles = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "10px",
    bgcolor: "background.paper",
    p: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "@media (max-width: 600px)": {
      width: 300,
    },
  } as SxProps,
};
